@switch (view) {
    @case (viewType.Empty) {
        <ms-pair-game-no-scoreboard class="card-scoreboard pair-game-no-scoreboard" [event]="event" />
    }
    @case (viewType.PairGame) {
        <ms-pair-game-scoreboard class="card-scoreboard" [event]="event" />
    }
    @case (viewType.SetGame) {
        <ms-set-game-scoreboard class="card-scoreboard set-game-scoreboard" [event]="event" [showSportIcon]="showSportIcon" />
    }
    @case (viewType.Tournament) {
        <ms-tournament-scoreboard class="card-scoreboard" [event]="event" />
    }
}
